export default __webpack_public_path__ + "static/media/flag_col.930c0c42.svg";